<template>
  <div class="employee">

    <div class="breadcrumb">
      <v-breadcrumb>
        <!-- <v-breadcrumb-item>
          <v-icon type="home"></v-icon>
          <a @click="() => $router.push('/student/dashboard')">Dashboard </a>
        </v-breadcrumb-item> -->
        <v-breadcrumb-item>
          <span>Applications</span>
        </v-breadcrumb-item>
      </v-breadcrumb>
    </div>

    <div style="width:100%;">
      <div class="table" v-if="assocApplications">
        <div class="trow">
          <div class="thead student-id" @click="() => sortApplications('user_seq')">Student ID</div>
          <div class="thead app-id" @click="() => sortApplications('seq_id')">Application ID</div>
          <div class="thead app-date" @click="() => sortApplications('display_date')">Applied Date</div>
          <div class="thead school-name" @click="() => sortApplications('display_school')">School Name</div>
          <div class="thead program-name" @click="() => sortApplications('name')">Program Name</div>
          <div class="thead intake" @click="() => sortApplications('selected_intake')">Intake</div>
          <div class="thead status" @click="() => sortApplications('status')">Status</div>
          <div class="thead actions">Actions</div>
        </div>
        <div class="trow">
          <div class="tdata student-id">
            <input type="text" placeholder="Search Student ID" v-model="searchStudentID" @keyup="(ev) => searchApplications('searchStudentID', ev.target.value)" />
          </div>
          <div class="tdata app-id">
            <input type="text" placeholder="Search Application ID" v-model="searchID" @keyup="(ev) => searchApplications('searchID', ev.target.value)" />
          </div>
          <div class="tdata app-date">
            <input type="text" placeholder="Search Application date" v-model="searchDate" @keyup="(ev) => searchApplications('searchDate', ev.target.value)" />
          </div>
          <div class="tdata school-name">
            <input type="text" placeholder="Search School name" v-model="searchSchool" @keyup="(ev) => searchApplications('searchSchool', ev.target.value)" />
          </div>
          <div class="tdata program-name">
            <input type="text" placeholder="Search Program name" v-model="searchProgram" @keyup="(ev) => searchApplications('searchProgram', ev.target.value)" />
          </div>
          <div class="tdata intake">
            <input type="text" placeholder="Search Intake" v-model="searchIntake" @keyup="(ev) => searchApplications('searchIntake', ev.target.value)" />
          </div>
          <div class="tdata status">
            <input type="text" placeholder="Search Status" v-model="searchStatus" @keyup="(ev) => searchApplications('searchStatus', ev.target.value)" />
          </div>
          <div class="tdata actions"></div>
        </div>
        <div v-for="application in filteredApplications" :key="application.id">
          <div class="trow">
            <div class="tdata student-id">
              <router-link :to="`edit-student-profile/${application.student_id}`">
                {{application.user_seq}}
              </router-link>
            </div>
            <div class="tdata app-id">{{application.seq_id}}</div>
            <div class="tdata app-date">{{application.display_date}}</div>
            <div class="tdata school-name">{{application.display_school}}</div>
            <div class="tdata program-name">{{application.name}}</div>
            <div class="tdata intake">{{application.selected_intake}}</div>
            <div class="tdata status">{{application.status}}</div>
            <div class="tdata actions">
              <div>
                <v-button type="primary" size="small" v-if="!applicationDetails.includes(application.id)" @click="() => showApplicationDetails(application)">Show Details</v-button>
                <v-button type="primary" size="small" v-if="applicationDetails.includes(application.id)" @click="() => hideApplicationDetails(application)">Hide Details</v-button>
              </div>
            </div>
          </div>
          <div class="details" v-if="applicationDetails.includes(application.id)">
            <ApplicationDetails :application="application" :fetchedUsers="fetchedUsers" :fetchedUserDetails="fetchedUserDetails" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import ApplicationDetails from '@/components/ApplicationDetails.vue'

export default {
  name: 'AssociateApplications',
  data () {
    return {
      searchStudentID: '',
      searchID: '',
      searchDate: '',
      searchSchool: '',
      searchProgram: '',
      searchVisaStatus: '',
      searchStatus: '',
      searchEmployee: '',
      searchIntake: '',
      applicationDetails: [],
      fetchedUsers: [],
      fetchedUserDetails: {},
      filteredApplications: null,
      fetchedApplications: null,
      sorted: {}
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'assocApplications',
      'fetchedUser'
    ])
  },
  watch: {
    user: {
      handler (val) {
        if (val) {
          if (!this.assocApplications) {
            this.$store.dispatch('getAssocApplications', val.ref)
          }
        }
      },
      immediate: true
    },
    assocApplications: {
      handler (val) {
        if (!val && this.user) {
          this.$store.dispatch('getAssocApplications', this.user.ref)
        } else if (val && val.length) {
          this.fetchedApplications = val
            .map(x => {
              x.display_date = `${('0' + (x.created_at.getMonth() + 1)).slice(-2)}-${('0' + (x.created_at.getDate())).slice(-2)}-${x.created_at.getFullYear()}`
              x.display_school = `${x.school_name}, ${x.school.campus}`
              x.student_id = `${x.userRef.id}`
              x.employee_name = x.assigned_to ? x.assigned_to.full_name : null

              let intake = []
              if (x.september) {
                intake.push('September')
              } else if (x.january) {
                intake.push('January')
              } else if (x.may) {
                intake.push('May')
              }
              x.intake = intake.join(', ')

              return x
            })

          this.filteredApplications = [...this.fetchedApplications]
        }
      },
      immediate: true
    },
    fetchedUser: {
      handler (val) {
        if (val) {
          this.fetchedUsers.push(val.uid)
          this.fetchedUserDetails[val.uid] = val
        }
      }
    }
  },
  methods: {
    userAction (data) {
      if (data.content === 'Logout') {
        fb.logout()
        this.$router.push('/auth')
      }
    },
    searchApplications (key, val) {
      this[key] = val

      if (!this.searchID && !this.searchDate && !this.searchSchool && !this.searchProgram && !this.searchStudentID && !this.searchStatus && !this.searchEmployee && !this.searchIntake) {
        this.filteredApplications = [...this.fetchedApplications]
      } else {
        this.filteredApplications = this.fetchedApplications.filter(x => {
           if (this.searchStudentID && (x.user_seq + '').indexOf(this.searchStudentID.toLowerCase()) == -1) {
            return false
          }
          if (this.searchID && x.seq_id.toLowerCase().indexOf(this.searchID.toLowerCase()) == -1) {
            return false
          }
          if (this.searchDate && x.display_date.toLowerCase().indexOf(this.searchDate.toLowerCase()) == -1) {
            return false
          }
          if (this.searchSchool && x.display_school.toLowerCase().indexOf(this.searchSchool.toLowerCase()) == -1) {
             return false
          }
          if (this.searchProgram && x.name.toLowerCase().indexOf(this.searchProgram.toLowerCase()) == -1) {
            return false
          }
          if (this.searchStatus && x.status.toLowerCase().indexOf(this.searchStatus.toLowerCase()) == -1) {
            return false
          }
          if (this.searchEmployee && x.employee_name.toLowerCase().indexOf(this.searchEmployee.toLowerCase()) == -1) {
            return false
          }
          if (this.searchIntake && (x.selected_intake || '').toLowerCase().indexOf(this.searchIntake.toLowerCase()) == -1) {
            return false
          } 
          return true
        })
      }
    },
    sortApplications (col) {
      let applications = [...this.filteredApplications]
      let sortedAscending = [...this.filteredApplications]
      
      sortedAscending.sort((x, y) => (x[col] || '') > (y[col] || '') ? 1 : (y[col] || '') > (x[col] || '') ? -1 : 0)
      if (this.sorted[col] === undefined) {
        this.sorted[col] = !sortedAscending.every((item, index) => item[col] === applications[index][col])
      } else {
        this.sorted[col] = !this.sorted[col]
      }

      if (this.sorted[col]) {
        this.filteredApplications = applications.sort((x, y) => (x[col] || '') > (y[col] || '') ? 1 : (y[col] || '') > (x[col] || '') ? -1 : 0)
      } else {
        this.filteredApplications = applications.sort((x, y) => (x[col] || '') > (y[col] || '') ? -1 : (y[col] || '') > (x[col] || '') ? 1 : 0)
      }
    },
    showApplicationDetails (application) {
      this.applicationDetails.push(application.id)
      if (!this.fetchedUsers.includes(application.userRef.id)) {
        this.$store.dispatch('getUserFetched', application.userRef.id)
      }
    },
    hideApplicationDetails (application) {
      this.applicationDetails.splice(this.applicationDetails.indexOf(application.id), 1)
    }
  },
  components: {
    ApplicationDetails
  }
}
</script>

<style scoped>
.breadcrumb {
  padding: 16px;
}
.applications-wrap {
  padding: 16px;
}
.table {
  width: 98%;
  margin: auto;
}
.table .trow {
  display: flex;
  flex-direction: row;
}
.table .thead {
  font-size: 13px;
  padding: 7px 6px;
  background-color: #404040;
  color: ivory;
  border: 1px solid rgba(255, 255, 240, .2);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.table .thead:first-child {
  border-top-left-radius: 2px;
}
.table .thead:last-child {
  border-top-right-radius: 2px;
}
.table .tdata {
  font-size: 12px;
  padding: 5px 6px;
  border: 1px solid rgba(131, 127, 127, 0.137);
  display: flex;
  align-items: center;
}
.table .tdata input {
  width: 100%;
  margin: auto;
  padding: 4px 7px;
  height: 28px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(0,0,0,.65);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-transition: all .3s;
  transition: all .3s;
}

.trow .student-id {
  width: 10%;
}
.trow .app-id {
  width: 10%;
}
.trow .app-date {
  width: 8%;
  justify-content: center;
}
.trow .school-name {
  width: 19%;
}
.trow .program-name {
  width: 19%;
}
.trow .intake {
  width: 12%;
}
.trow .status {
  width: 10%;
}
.trow .actions {
  min-width: 12%;
  width: 12%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.trow .actions div {
  margin-top: 4px;
}

.trow .options .ant-select {
  width: 100% !important;
}
.details {
  padding: 4px 16px;
  border: 1px solid rgba(0, 21, 41, .1);
}
.uploaded-documents {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.uploaded-documents div {
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/Associate/AssociateApplications.vue